<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Parent App Registrations</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row">
            <div class="mr-2">
              <bulk-upload-parent v-if="pagepermission.insertable" @created="handleCreated"/>
            </div>
            <div>
              <add-parent v-if="pagepermission.insertable" @created="handleCreated"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row align-items-center mb-2">
          <!-- Session Select -->
<!--          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedRelation"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleRelationChange"
              :filterOption="false"
              :defaultValue="0"
            >
            <template>
              <a-select-option :value="0">Father</a-select-option>
              <a-select-option :value="1">Mother</a-select-option>
              <a-select-option :value="2">Guardian</a-select-option>
            </template>
            </a-select>
          </div>-->
          <div class="col-md-2 col-12 mb-2">
            <a-checkbox @change="onChangeEnrollStudents($event)">
              Students
            </a-checkbox>
          </div>
          <div class="col-md-2 col-12 mb-2" v-if="showEnrollStudents">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
              <template v-for="schoolSession in schoolSessions">
                <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                </a-select-option>
              </template>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2" v-if="showEnrollStudents">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="Select class"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="null"
                >All Classes</a-select-option
                >
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option
                    :value="schoolClass.id"
                    :key="schoolClass.id"
                  >
                    {{ schoolClass.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Section Select -->
          <div class="col-md-2 col-12 mb-2" v-if="showEnrollStudents">
            <a-spin :spinning="sectionSpinning">
              <a-select
                size="large"
                v-model="selectedSection"
                placeholder="All Sections"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <a-select-option :value="undefined"
                >All Sections</a-select-option
                >
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                    {{ section.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Parent Search -->
          <div class="col-md-4 col-12 mb-2" v-if="!showEnrollStudents">
            <div class="text-right">
              <a-input-search
                placeholder="Search by name, phone.."
                size="large"
                v-model="search"
                @search="searchParents"
              />
            </div>
          </div>
          <!-- Student Search -->
          <div class="col-md-2 col-12 mb-2" v-if="showEnrollStudents">
            <a-select
              size="large"
              v-model="selectedStatus"
              placeholder="Enroll Status"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleStatusSelect"
              :filterOption="false"
              :defaultValue="undefined"
            >
              <a-select-option :value="undefined"
              >All</a-select-option
              >
              <a-select-option :value="ENROLLED" :key="ENROLLED">Enrolled</a-select-option>
              <a-select-option :value="NONENROLLED" :key="NONENROLLED">Non Enrolled</a-select-option>
            </a-select>
          </div>
          <div class="col-md-2 col-12 mb-2 text-right" v-if="showEnrollStudents">
            <a-button
              key="submit"
              type="primary"
              :loading="loading"
              @click="handleExport"
            >Export</a-button
            >
          </div>
          <div class="col-md-4 col-12 mb-2" v-if="showEnrollStudents">
            <div class="text-right">
              <a-input-search
                placeholder="Search by student name, code.."
                size="large"
                v-model="searchStudent"
                @search="handleSearchStudents"
              />
            </div>
          </div>
<!--          <div class="col-md-6 col-12 mb-2 text-md-right" v-if="selectedRowKeys.length">
            <a href="javascript:;" class="btn btn btn-danger btn-with-addon"
              @click="handleDeleteSelected"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete Selected
            </a>
          </div>-->
        </div>
        <div class="card">
          <div class="card-body">
            <registered-parent-table v-if="!showEnrollStudents" :rolesetting="pagepermission" :data="data" :loading="loading"  @updateTable="handleUpdateTable" @selectChange="handleTableSelect"/>
            <enrolled-students-table v-if="showEnrollStudents" :rolesetting="pagepermission" :data="enrolledStudentsData" :loading="loading"  @updateTable="handleUpdateTable" @selectChange="handleTableSelect"/>
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :show-total="total => `Total ${meta.total} items`"
              v-model="current"
              :total="meta.total"
              :pageSize.sync="pageSize"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// import RegisteredParentTable from '@/components/parentregistration/Table/index'
import RegisteredParentTable from '@/components/appregistration/parentregistration/Table/index'
import EnrolledStudentsTable from '@/components/appregistration/studentappenrollment/Table/index'
import AddParent from '@/components/appregistration/parentregistration/Forms/Add/index'
import BulkUploadParent from '@/components/appregistration/parentregistration/Forms/Bulk/index'
import moment from 'moment'

import { find } from 'lodash'

// const pagename = 'student'
export default {
  components: {
    EnrolledStudentsTable,
    RegisteredParentTable,
    AddParent,
    BulkUploadParent,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('registeredparent', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.getParents(true)
    this.getEnrolledStudents(true)
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
  },
  created() {
    // this.searchParents = debounce(this.searchParents, 1000)
    // this.searchParents = debounce(this.searchParents, 1000)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: true,
      visible: false,
      data: [],
      meta: {},
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      current: 1,
      pageSize: 10,
      selectedRelation: 0,
      sectionSpinning: false,
      classSpinning: false,
      search: null,
      selectedRowKeys: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
      showEnrollStudents: false,
      selectedSession: undefined,
      enrolledStudentsData: [],
      selectedClass: undefined,
      selectedSection: undefined,
      selectedStatus: undefined,
      ENROLLED: 'ENROLLED',
      NONENROLLED: 'NON-ENROLLED',
      searchStudent: undefined,
    }
  },
  methods: {
    moment,
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getParents: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      this.$http.get('/api/parent/registered', {
        params: {
          limit: this.pageSize,
          page: page,
          search: this.search,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    getEnrolledStudents: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      this.$http.get('/api/parent/student/app-enrollments', {
        params: {
          limit: this.pageSize,
          page: page,
          session_id: this.selectedSession,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          enroll_status: this.selectedStatus,
          search: this.searchStudent,
        },
      }).then(({ data }) => {
        this.loading = false
        this.enrolledStudentsData = data.data
        let { age, ...meta } = data
        console.log(this.enrolledStudentsData)
        this.meta = meta
      })
    },
    searchParents: function(e) {
      // this.search = e.target.value
      this.getParents(true)
    },
    handleSearchStudents: function(e) {
      // this.search = e.target.value
      this.getEnrolledStudents(true)
    },
    handleCreated: function() {
      this.getParents()
    },
    handleUpdateTable: function() {
      this.getParents()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getParents()
    },
    onChange(current) {
      this.current = current
      if (this.showEnrollStudents) {
        this.getEnrolledStudents()
      } else {
        this.getParents()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses()
      this.getStudents()
    },
    handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
      // this.getParents()
      this.getEnrolledStudents()
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
      } else {
        this.selectedSection = undefined
      }
      this.getEnrolledStudents()
    },
    handleStatusSelect(value) {
      if (value) {
        this.selectedStatus = value
      } else {
        this.selectedStatus = undefined
      }
      this.getEnrolledStudents()
    },
    handleRelationChange (value) {
      /*  (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses() */
      this.getParents()
    },
    handleDeleteSelected() {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete the selected parent?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/students', {
              params: {
                student_ids: this.selectedRowKeys,
              },
            })
            .then(() => {
              this.handleUpdateTable()
              this.selectedRowKeys = []
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'The selected students were deleted successfully',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    onChangeEnrollStudents(e) {
      this.showEnrollStudents = false
      if (e.target.checked) {
        this.showEnrollStudents = true
      }
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleExport() {
      this.classSpinning = true

      let postData = {
        session_id: this.selectedSession,
        class_id: this.selectedClass,
        section_id: this.selectedSection,
        enroll_status: this.selectedStatus,
      }
      const header = {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        responseType: 'blob',
      }
      var filename = 'AppEnrolledStudents'
      this.$http.post('api/parent/student/bulk/app-enrollments',
        postData,
        header)
        .then((res) => {
          var FILE = window.URL.createObjectURL(new Blob([res.data])) // new Blob([res.data], { type: 'application/json' }) // window.URL.createObjectURL(new Blob([res.data]))
          var docURL = document.createElement('a')
          docURL.href = FILE
          docURL.setAttribute('download', `${filename}${this.moment(this.date).format('YYYY-MM-DD')}.xlsx`)
          document.body.appendChild(docURL)
          docURL.click()
          this.disablebtn = false
          this.classSpinning = false
        })
        .catch((err) => {
          console.log(err)
          this.disablebtn = false
          this.classSpinning = false
        })
    },
  },

}
</script>
<style>
.error { padding: 25px 5px; }
</style>
